var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
__export(exports, {
  default: () => i18n_default
});
var i18next = __toModule(require("i18next"));
var import_i18next_locize_backend = __toModule(require("i18next-locize-backend"));
var import_moment = __toModule(require("moment"));
var import_constants = __toModule(require("../../constants"));
var import_utils = __toModule(require("../../model/utils"));
const _locale = import_constants.I18N_DEFAULT_LANGUAGE;
const BACKEND_OPTIONS = {
  projectId: import_constants.LOCIZE_PROJECT_ID,
  apiKey: import_constants.LOCIZE_API_KEY,
  referenceLng: _locale,
  reloadInterval: false
};
const i18nextInstance = i18next.createInstance();
function init() {
  return __async(this, null, function* () {
    yield i18nextInstance.use(import_i18next_locize_backend.default).init({
      lng: _locale,
      fallbackLng: false,
      ns: ["common"],
      defaultNS: "common",
      saveMissing: true,
      backend: BACKEND_OPTIONS,
      interpolation: {
        format: function(value, format) {
          if (format.includes("date")) {
            const splitFormat = format.split("|")[1];
            return (0, import_moment.default)((0, import_utils.formatDate)(value)).format(splitFormat);
          }
          return value;
        }
      }
    });
  });
}
const translate = (key, options) => __async(void 0, null, function* () {
  if (!i18nextInstance.isInitialized) {
    yield init();
  }
  return i18nextInstance.t(key, options);
});
const setLocale = (locale) => __async(void 0, null, function* () {
  return yield i18nextInstance.changeLanguage(locale);
});
var i18n_default = {
  setLocale,
  translate
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {});
